import { State } from 'components/Layout'
import { ProductVariant } from 'lib/hooks/use-products'
import { useContext } from 'react'
import { currency } from 'lib/currency'
import i from 'i18next'

type Props = {
	variant: ProductVariant
	onClick?: () => void
}

export default function BuyButton({ variant, onClick }: Props ) {
	const { addToCart } = useContext( State )
	return (
		<button
			className="button"
			onClick={onClick ?? ( () => addToCart( variant ) )}
			disabled={!variant.availableForSale}
		>
			{!variant.availableForSale
				? i.t( 'product.button.notinstockshort' )
				: i.t( 'product.button.addshort' )}
			{' — '}
			{!!variant.compareAtPrice?.amount && (
				<span className="from">
					{currency.format( variant.compareAtPrice.amount )}
				</span>
			)}
			{currency.format( variant.priceV2.amount )}
			<style jsx>{`
				.from {
					margin-inline: .5em;
					opacity: .6;
					text-decoration: line-through;
				}
			`}</style>
		</button>
	)
}
